module.exports = __webpack_public_path__ + "img/remaining.f1de59c2.svg";